import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Loading from '@ifit/mp-loading';
import { useGetOneRowQuery } from '../../../client/query/rows';
import { useEntitiesInfiniteQuery } from '../../../client/query/entities';
import NotFound from '../../../helpers/not-found';
import InfiniteScroll from '../../../components/infinite-scroll';
import GridSection from '../../../components/grid-section';
import { getSearchState } from '../../search/state/search-state';
import useToolbarTitle from '@ifit/hooks/useToolbarTitle';
import { setLastTitle } from '../../../store/to-native';
import { QueryParams } from '../../routes';

const Query: React.FC = () => {
  const { querySlug } = useParams<QueryParams>();
  const decodedQuerySlug = decodeURIComponent(querySlug);
  const {
    data: row,
    isLoading: rowLoading,
    isError: rowError,
  } = useGetOneRowQuery(querySlug);

  useToolbarTitle(
    decodedQuerySlug,
    {
      buttonStyle: 'back',
    },
    () => setLastTitle(decodedQuerySlug),
  );

  const {
    dataMemo: { reset, hasMoreItems, data: cards },
    fetchNextPageCallback,
    query: { isLoading, isError },
  } = useEntitiesInfiniteQuery((row?.query as { params: unknown })?.params, {
    enabled: rowLoading === false && rowError === false,
  });
  useEffect(() => {
    if (row) {
      getSearchState().setViewContext({
        ...(row as any).query?.params,
        categories: (row as any).query?.params?.categories?.map(
          category => category.name,
        ),
      });
    }
  }, [row]);

  if (rowLoading || isLoading || !cards) {
    return <Loading absolute data-testid={'query-loading'} />;
  }
  if (rowError || isError) {
    return <NotFound />;
  }

  return (
    <div className="query-view" data-testid={'data-grid'}>
      <InfiniteScroll
        loadMore={fetchNextPageCallback}
        reset={reset}
        hasMoreItems={hasMoreItems}
        libraryCards={cards}
      >
        <GridSection showCategory />
      </InfiniteScroll>
    </div>
  );
};

export default Query;
